/*
 * Header Bracci: comportamento da barra de anúncio, mega menu, busca e menu do celular.
 * Portado do tema antigo (Dawn 15.4) sem depender do global.js do Dawn.
 *
 * Os eventos são delegados no document, então continuam funcionando quando o editor
 * de temas recarrega a seção. O arquivo é incluído pelas duas seções do header;
 * a trava abaixo garante que rode uma vez só.
 */
(() => {
  if (window.BracciHeader) return;

  const root = document.documentElement;
  const DESKTOP = window.matchMedia('(min-width: 990px)');
  const PANEL_TRANSITION = 200;

  /* ---------- Trava de rolagem ---------- */

  const locks = new Set();

  function setLock(key, active) {
    if (active) locks.add(key);
    else locks.delete(key);
    root.classList.toggle('bh-locked', locks.size > 0);
  }

  /* ---------- Altura do header ---------- */

  // A altura da barra + header vai para --bh-header-bottom (menu do celular e recuo do
  // header transparente) e para --header-height, que alguns componentes do Fabric usam.
  function updateOffsets() {
    const header = document.querySelector('[data-bh-header]');
    if (!header) return;

    const bar = document.querySelector('[data-bh-announcement]');
    const hasBar = Boolean(bar && !bar.hidden);
    header.classList.toggle('bh--no-announcement', !hasBar);

    const barHeight = hasBar ? bar.offsetHeight : 0;
    const bottom = Math.round(barHeight + header.offsetHeight);
    root.style.setProperty('--bh-announcement-height', `${barHeight}px`);
    root.style.setProperty('--bh-header-bottom', `${bottom}px`);
    document.body.style.setProperty('--header-height', `${bottom}px`);
    document.body.style.setProperty('--header-group-height', `${bottom}px`);
  }

  let resizeObserver;

  function observeHeader() {
    resizeObserver?.disconnect();
    resizeObserver = new ResizeObserver(updateOffsets);
    document.querySelectorAll('[data-bh-header], [data-bh-announcement]').forEach((element) => {
      resizeObserver.observe(element);
    });
    updateOffsets();
  }

  /* ---------- Barra de anúncio ---------- */

  let rotationTimer;

  function startRotation() {
    clearInterval(rotationTimer);

    const slides = document.querySelectorAll('.bh-announcement__slide');
    const speed = window.bracciAnnouncementSpeed;
    if (slides.length < 2 || !speed) return;

    let current = 0;
    rotationTimer = setInterval(() => {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-active');
      slides[current].removeAttribute('aria-hidden');
    }, speed);
  }

  /* ---------- Mega menu ---------- */

  function closeMegaMenus(except) {
    document.querySelectorAll('[data-bh-mega][open]').forEach((details) => {
      if (details !== except) details.open = false;
    });
  }

  /* ---------- Busca ---------- */

  function closeSearch() {
    document.querySelectorAll('[data-bh-search][open]').forEach((details) => {
      details.open = false;
    });
  }

  /* ---------- Menu do celular ---------- */

  function openPanel(details, lockKey) {
    details.open = true;
    requestAnimationFrame(() => details.classList.add('is-open'));
    if (lockKey) setLock(lockKey, true);
  }

  function closePanel(details, lockKey) {
    if (!details.open) return;
    details.classList.remove('is-open');
    if (lockKey) setLock(lockKey, false);
    setTimeout(() => {
      if (!details.classList.contains('is-open')) details.open = false;
    }, PANEL_TRANSITION);
  }

  function closeDrawer() {
    document.querySelectorAll('[data-bh-drawer]').forEach((drawer) => {
      drawer.querySelectorAll('[data-bh-drawer-sub]').forEach((sub) => closePanel(sub));
      closePanel(drawer, 'drawer');
    });
  }

  /* ---------- Eventos ---------- */

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    // Menu do celular: abre e fecha com a animação lateral.
    const drawerToggle = target.closest('.bh-drawer__toggle');
    if (drawerToggle) {
      event.preventDefault();
      const drawer = drawerToggle.closest('[data-bh-drawer]');
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        closeSearch();
        openPanel(drawer, 'drawer');
      }
      return;
    }

    if (target.closest('[data-bh-drawer-close]')) {
      closeDrawer();
      return;
    }

    const subToggle = target.closest('[data-bh-drawer-sub] > summary');
    if (subToggle) {
      event.preventDefault();
      openPanel(subToggle.parentElement);
      return;
    }

    const back = target.closest('[data-bh-drawer-back]');
    if (back) {
      closePanel(back.closest('[data-bh-drawer-sub]'));
      return;
    }

    // Busca: botão de fechar e véu sobre a página.
    if (target.closest('[data-bh-search-close]')) {
      event.preventDefault();
      closeSearch();
      return;
    }

    // Mega menu: clicar fora fecha o que estiver aberto.
    const openMega = document.querySelector('[data-bh-mega][open]');
    if (openMega && !openMega.contains(target)) openMega.open = false;
  });

  // Um mega menu aberto por vez, como no tema antigo.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;

      if (details.matches('[data-bh-mega]') && details.open) {
        closeMegaMenus(details);
        closeSearch();
      }

      if (details.matches('[data-bh-search]')) {
        setLock('search', details.open);
        if (details.open) {
          closeMegaMenus();
          const input = details.querySelector('input[type="search"]');
          requestAnimationFrame(() => input?.focus());
        }
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const openSearch = document.querySelector('[data-bh-search][open]');
    if (openSearch) {
      closeSearch();
      openSearch.querySelector('summary')?.focus();
      return;
    }

    const openDrawer = document.querySelector('[data-bh-drawer].is-open');
    if (openDrawer) {
      closeDrawer();
      openDrawer.querySelector('summary')?.focus();
      return;
    }

    const openMega = document.querySelector('[data-bh-mega][open]');
    if (openMega) {
      openMega.open = false;
      openMega.querySelector('summary')?.focus();
    }
  });

  document.addEventListener('click', (event) => {
    const close = event.target instanceof Element && event.target.closest('[data-bh-announcement-close]');
    if (!close) return;
    close.closest('[data-bh-announcement]').hidden = true;
    updateOffsets();
  });

  // Ao passar para o desktop, o menu do celular não pode ficar aberto travando a página.
  DESKTOP.addEventListener('change', (event) => {
    if (event.matches) closeDrawer();
  });

  /* ---------- Header transparente: fica sólido depois do banner ---------- */

  // Na home, o header transparente só faz sentido sobre o banner. Depois que o
  // banner sai da tela, o header ganha a cor de fundo normal; senão o conteúdo claro
  // aparece borrado através dele (e o Chrome às vezes nem redesenha o desfoque).
  // No desktop o Fabric rola o .page-wrapper, não a janela: o scroll é ouvido na
  // captura, o que pega os dois.
  let solidFrame = null;

  function updateSolid() {
    solidFrame = null;
    const header = document.querySelector('[data-bh-header].bh--transparent');
    if (!header) return;
    if (header.dataset.solidOnScroll === 'false') {
      header.classList.remove('bh--solid');
      return;
    }
    const hero = document.querySelector('#MainContent > .shopify-section');
    const headerBottom = header.getBoundingClientRect().bottom;
    const heroBottom = hero ? hero.getBoundingClientRect().bottom : 0;
    header.classList.toggle('bh--solid', heroBottom <= headerBottom + 1);
  }

  function queueSolid() {
    if (solidFrame === null) solidFrame = requestAnimationFrame(updateSolid);
  }

  document.addEventListener('scroll', queueSolid, { capture: true, passive: true });
  window.addEventListener('resize', queueSolid, { passive: true });

  /* ---------- Início e editor de temas ---------- */

  function init() {
    observeHeader();
    startRotation();
    updateSolid();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => requestAnimationFrame(init));

  window.BracciHeader = { updateOffsets, closeDrawer, closeSearch, closeMegaMenus };
})();
